<!-- SPDX-License-Identifier: LicenseRef-MMS-WIRE -->
<!-- Copyright (c) 2016-2026 Metal Management Solutions (Pty) Ltd -->

@if (appScope.isAuthenticated$ | async) {
  <div appUserInteraction class="body" [ngClass]="currentTheme">
    @if (!headerData.hidePageLoader) {
      <ngx-loading-bar [color]="loadingBarColour"></ngx-loading-bar>
    }
    <main-header></main-header>
    <main-sidenav></main-sidenav>
    <src-legal-footer class="hideonprint"></src-legal-footer>
    @if (appScope.userOnboarded | async) {
      <comment-drawer [ngClass]="{'showing_comments_panel': showing_comments_panel}" class="hideonprint"></comment-drawer>
      <print-content></print-content>
    }
  </div>
}

@if (appScope.authFailed$ | async) {
    <src-no-account [ngClass]="currentTheme"></src-no-account>
}
